export default "__VITE_ASSET__C9i7jRUi__"